// src/app/contractor.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Contractor } from '../objects/Contractor';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContractorService { 
  private apiUrl = environment.apiUrl +'Contractors'; // Replace with your API endpoint
  constructor(private http: HttpClient) {}

  getContractors(): Observable<Contractor[]> {
    return this.http.get<Contractor[]>(this.apiUrl);
  }

  getContractorsByProvider(providerId: number): Observable<Contractor[]> {
    return this.http.get<Contractor[]>(`${this.apiUrl}/ByProvider/${providerId}`);
  }

  getContractorById(id: number): Observable<Contractor> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<Contractor>(url);
  }

  getContractorImageUrl(id: number): string {
    return `${this.apiUrl}/${id}/image`;
  }

  addContractor(contractor: Contractor): Observable<Contractor> {
    return this.http.post<Contractor>(this.apiUrl, contractor);
  }

  editContractor(contractor: Contractor): Observable<Contractor> {
    const url = `${this.apiUrl}/${contractor.id}`;
    return this.http.put<Contractor>(url, contractor);
  }

  deleteContractor(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
